import React from 'react';

export const RedirectionPage = () => {
  const params = new URLSearchParams(location.search);
  const p = params.get('p');
  if (p) window.location.href = p;
  else window.location.href = '/';
  return <div></div>;
};